import topology from "@highcharts/map-collection/custom/world.topo.json";
import Highcharts from "highcharts";
import Accessibility from "highcharts/modules/accessibility";
import HighchartsMap from "highcharts/modules/map";
import HighchartsReact from "highcharts-react-official";
import React from "react";
import { useIntl } from "react-intl";

import { themeSlice } from "@tdp/common/theme";
import { useSelector } from "@tdp/core";
import { EmptyState } from '@tdp/modules/apps'

import { Alignment, containerStyle, getStyles } from "./Charts.Styles";
import { AxisType, ChartType, ICountryData, removeWatermark } from "./IAnalyticsCharts";

// Initialize the Highcharts accessibility module
// https://www.highcharts.com/docs/accessibility/accessibility-module#describing-your-chart
Accessibility(Highcharts);
HighchartsMap(Highcharts);

export const ChartMapBubble: React.FC<{ data?: ICountryData[]; legend: string }> = ({ data, legend }) => {
  const currentTheme = useSelector(themeSlice.selectors.getCurrentTheme);
  const style = getStyles(currentTheme);
  const intl = useIntl();

  if (!data) {
    return <EmptyState />;
  }

  const options = {
    chart: {
      backgroundColor: style.backgroundColor,

      map: topology,
      animation: false
    },
    title: null,
    mapNavigation: {
      enabled: true,
      buttonOptions: {
        align: Alignment.Right
      }
    },
    series: [
      {
        "countries": "Country/Region",
        name: intl.formatMessage({ defaultMessage: "Country/Region", description: "Country or region" }),
        color: style.legend,
        enableMouseTracking: false,
        showInLegend: false
      },
      {
        type: ChartType.MAP_BUBBLE,
        name: legend,
        joinBy: [AxisType.IsoA3, "name"],
        data,
        maxSize: "20%",
        color: style.lineColors[0]
      }
    ],
    tooltip: style.tooltip,
    legend: {
      itemStyle: {
        color: style.legend
      },
      align: Alignment.Left
    },
    ...removeWatermark
  };


  return <HighchartsReact constructorType={"mapChart"} highcharts={Highcharts} options={options} containerProps={containerStyle} />;
};

export default React.memo(ChartMapBubble);
